/* ============================================================
   STARCAST Brand JavaScript
   Animations · Scroll Reveal · FAQ · Notifications · Tabs
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. SCROLL REVEAL ──────────────────────────────────── */
  function initScrollReveal() {
    const els = document.querySelectorAll('.sc-reveal');
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  /* ── 2. FAQ ACCORDION ──────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.sc-faq-item').forEach((item) => {
      const q = item.querySelector('.sc-faq-question');
      if (!q) return;
      q.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.sc-faq-item.is-open').forEach((o) => {
          if (o !== item) o.classList.remove('is-open');
        });
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* ── 3. CINEMA / SCENARIO TABS ─────────────────────────── */
  function initTabs() {
    document.querySelectorAll('[data-sc-tab-group]').forEach((group) => {
      const buttons = group.querySelectorAll('[data-sc-tab]');
      const panels  = group.querySelectorAll('[data-sc-panel]');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.scTab;
          buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
          panels.forEach((p) => p.classList.toggle('is-active', p.dataset.scPanel === target));
        });
      });

      // Activate first
      if (buttons[0]) buttons[0].click();
    });
  }

  /* ── 4. REVIEWS SLIDER ─────────────────────────────────── */
  function initReviewsSlider() {
    document.querySelectorAll('.sc-reviews-track').forEach((track) => {
      const prev = track.closest('.sc-reviews-wrap')?.querySelector('[data-sc-prev]');
      const next = track.closest('.sc-reviews-wrap')?.querySelector('[data-sc-next]');
      if (!prev || !next) return;

      const card = track.querySelector('.sc-review-card');
      const step = card ? card.offsetWidth + 24 : 300;

      next.addEventListener('click', () => track.scrollBy({ left: step, behavior: 'smooth' }));
      prev.addEventListener('click', () => track.scrollBy({ left: -step, behavior: 'smooth' }));
    });
  }

  /* ── 5. PURCHASE NOTIFICATIONS ─────────────────────────── */
  function initNotifications() {
    const container = document.getElementById('sc-notification');
    if (!container) return;

    const nameEl   = container.querySelector('.sc-notification-name');
    const timeEl   = container.querySelector('.sc-notification-time');
    const closeBtn = container.querySelector('.sc-notification-close');

    // Pull notifications from data attribute (set by Liquid)
    const raw = container.dataset.notifications || '[]';
    let notifications = [];
    try { notifications = JSON.parse(raw); } catch (e) {}

    if (!notifications.length) return;

    let idx = 0;
    let timeoutId;
    let hideTimeoutId;

    function showNext() {
      const item = notifications[idx % notifications.length];
      idx++;

      nameEl.textContent = item.name;
      timeEl.textContent = item.time;

      container.classList.remove('is-hiding');
      container.classList.add('is-visible');

      hideTimeoutId = setTimeout(() => {
        container.classList.add('is-hiding');
        setTimeout(() => container.classList.remove('is-visible', 'is-hiding'), 500);
      }, 4500);

      const interval = 6000 + Math.random() * 6000;
      timeoutId = setTimeout(showNext, interval + 5000);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        clearTimeout(timeoutId);
        clearTimeout(hideTimeoutId);
        container.classList.add('is-hiding');
        setTimeout(() => {
          container.style.display = 'none';
        }, 500);
      });
    }

    // Start after 5s delay
    setTimeout(showNext, 5000);
  }

  /* ── 6. HERO VIDEO LAZY LOAD ────────────────────────────── */
  function initHeroVideo() {
    const video = document.querySelector('.sc-hero__video[data-src]');
    if (!video) return;

    const src = video.dataset.src;
    if (src) {
      video.src = src;
      video.load();
    }
  }

  /* ── 7. HEADER SCROLL EFFECT ────────────────────────────── */
  function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 60) {
        header.style.background = 'rgba(7, 7, 15, 0.95)';
      } else {
        header.style.background = 'rgba(7, 7, 15, 0.85)';
      }
      lastY = y;
    }, { passive: true });
  }

  /* ── 8. FEATURE CARD MOUSE GLOW ─────────────────────────── */
  function initCardGlow() {
    document.querySelectorAll('.sc-feature-card').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
        const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
        card.style.setProperty('--mouse-x', `${x}%`);
        card.style.setProperty('--mouse-y', `${y}%`);
      });

      card.addEventListener('mouseleave', () => {
        card.style.removeProperty('--mouse-x');
        card.style.removeProperty('--mouse-y');
      });
    });
  }

  /* ── 9. AIRFLOW ANIMATION (Cooling section) ──────────────── */
  function initAirflowParticles() {
    const wrap = document.querySelector('.sc-cooling-visual');
    if (!wrap) return;

    for (let i = 0; i < 12; i++) {
      const p = document.createElement('div');
      p.className = 'sc-airflow-particle';
      p.style.top    = `${15 + Math.random() * 70}%`;
      p.style.left   = `${Math.random() * 20}%`;
      p.style.width  = `${40 + Math.random() * 60}px`;
      p.style.animationDelay  = `${Math.random() * 3}s`;
      p.style.animationDuration = `${2.5 + Math.random() * 2}s`;
      p.style.opacity = (0.3 + Math.random() * 0.6).toString();
      wrap.appendChild(p);
    }
  }

  /* ── 10. FLOATING TRUST BADGE COUNTER ───────────────────── */
  function initCounters() {
    document.querySelectorAll('[data-sc-counter]').forEach((el) => {
      const target = parseInt(el.dataset.scCounter, 10);
      const duration = 1800;
      const start = performance.now();

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          io.unobserve(el);

          function step(now) {
            const p = Math.min((now - start) / duration, 1);
            const ease = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(ease * target).toLocaleString() + (el.dataset.scCounterSuffix || '');
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });

      io.observe(el);
    });
  }

  /* ── INIT ALL ───────────────────────────────────────────── */
  function init() {
    initScrollReveal();
    initFAQ();
    initTabs();
    initReviewsSlider();
    initNotifications();
    initHeroVideo();
    initHeaderScroll();
    initCardGlow();
    initAirflowParticles();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
